import LoadingWrapper from "../../../shared/components/LoadingWrapper";
import { cpColumns, cpTableCols } from "../../models/vessel-details.const";
import { getCpSpeedConsumption, togglePerfTableCol } from "../../services/vessel-details.service";
import { PerfManageColsMenu } from "../PerfManageColsMenu";
import { PerfTable } from "./PerfTable";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// TODO Interface for speed info
export const CpTable = () => {
  const [isLoading, setLoading] = useState(false);
  const { imoNumber, vesselCode, vesselName } = useParams();
  const [speedInfo, setSpeedInfo] = useState<any[]>([]);

  speedInfo.sort((a, b) => a?.CP_CONTRACT_VESSEL_SPEED - b?.CP_CONTRACT_VESSEL_SPEED);
  const speedDataBallast = speedInfo?.filter((user) => user.VESSEL_TYPE === "B");
  const speedDataLaden = speedInfo?.filter((user) => user.VESSEL_TYPE === "L");

  useEffect(() => {
    const speedFetchData = async () => {
      try {
        setLoading(true);
        const speed = await getCpSpeedConsumption(imoNumber, vesselCode, vesselName);
        setSpeedInfo(speed);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    speedFetchData();
  }, [imoNumber, vesselCode, vesselName, setSpeedInfo]);

  const [visCols, setVisCols] = useState<string[]>(cpTableCols);
  const ecoCount = cpColumns.length - visCols.length;

  const BallastMenuButton = PerfManageColsMenu(
    ecoCount,
    cpColumns,
    visCols,
    togglePerfTableCol(setVisCols),
    "CP_CONTRACT_VESSEL_SPEED",
  );

  return (
    <LoadingWrapper isLoading={isLoading} loadingIndicatorClassName="text-green" loadingIndicatorSize="lg">
      {PerfTable(
        cpColumns,
        "CP_CONTRACT_VESSEL_SPEED",
        visCols,
        speedInfo,
        speedDataBallast,
        speedDataLaden,
        BallastMenuButton,
      )}
    </LoadingWrapper>
  );
};
